import { Injectable } from '@angular/core';
import type { EmailFormInterface } from '@zaoblako/shared/modules/integration/dtos/email/email-form.dto';
import type { EmailTestSmtpResultInterface } from '@zaoblako/shared/modules/integration/dtos/email/email-test-smtp-result.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntegrationEmailService extends BaseService {
  protected baseUrl = '/debts/integration/email';

  public testConnection(body: EmailFormInterface): Observable<EmailTestSmtpResultInterface> {
    return this.http.post<EmailTestSmtpResultInterface>(`${this.baseUrl}/test-smtp`, body);
  }
}
